import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import {
  NgbModal,
  NgbActiveModal,
  ModalDismissReasons,
} from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { any, object } from 'underscore';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { StoreInfoService } from 'src/app/store-info.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './theme-select-page.component.html',
  styleUrls: ['./theme-select-page.component.scss'],
})
export class ThemeSelectPageComponent implements OnInit {
  toastSuccess = false;
  selectIsLoadingId = [];

  modalRef;

  themeList = [];
  previewedTheme;
  themeselectId;
  companyStore;
  currentThemeId: number | null = null;

  store_id;
  bearer;
  isLoading;

  onerror = [];
  themeName = '';
  previewImage = '';

  storeInfo$ = this.storeInfoService.getStoreInfos();

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private router: Router,
    private formBuilder: FormBuilder,
    private utils: UtilitiesService,
    private storeInfoService: StoreInfoService
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    this.themeName = localStorage.getItem('themeName');
    this.themeselectId = Number(localStorage.getItem('themeselectId'));
    this.previewImage = localStorage.getItem('previewImage');
    this.getStoreInfo();
  }

  get isCurrentTheme(): boolean {
    return this.currentThemeId !== null && this.currentThemeId === this.themeselectId;
  }

  // Catalog is a company-store theme; other stores see it but can't apply it.
  get catalogLocked(): boolean {
    return this.companyStore !== true && this.themeName === 'Catalog';
  }

  getStoreInfo() {
    this.storeInfo$.subscribe((res) => {
      this.companyStore = res.config.is_company_store;
      // estore/update stores the applied preset's id as the store's theme_id.
      this.currentThemeId = Number(res?.theme_id) || null;
    });
  }

  selectThemePreset() {
    this.selectIsLoadingId.push(this.themeselectId);

    this.svc.selectTheme(this.themeselectId, this.bearer).subscribe(
      (res: any) => {
        console.log('selectThemePreset', { res });

        this.storeInfoService.fetchStoreInfo();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!')
        );
        this.toastSuccess = true;
      },
      (error) => {
        console.log('ERROR', { error });
        this.toastSuccess = false;
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      }
    );
  }
}
